<template>
  <div>
    <h3 class="title">個人中心</h3>
    <hr>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.title{
    font-size:22px;
    font-weight:400;
    color:rgba(82,81,158,1);
    line-height:32px;
    margin-top: 10px;
  }
  hr{
    height: 2px;
    background-color: #4f4e95;
    margin-bottom: 20px;
  }
</style>